import { useEffect, useMemo } from 'react';
import { createElement } from 'react';
import PagImg from '../commons/pag-img';
import TypedText from '../commons/typed-text';
import './style.less';
import { readDateTime } from '../commons/utils';
import { getFormatDate, getGreeting } from '../commons/utils/time';
const constMap = {
    robotImg: '/assets/imgs/avatar/xiaozhi.pag',
    robotImgDefault: '/assets/imgs/avatar/xiaozhi-default.png',
    robotId: 'xiaozhi',
    robotName: '工小智',
    robotAvatar: '/assets/imgs/avatar/icon-xiaozhi.pag',
    robotAvatarDefault: '/assets/imgs/avatar/icon-xiaozhi-default.png'
};
function CardGreet(props) {
    const { pageData = {}, cardStyle } = props;
    const { isHistory = false } = pageData;
    const chatMsgs = {
        showAnimation: 1
    };
    const pvParameter = pageData?.buttons?.[0]?.pvParameter || {};
    const dateInfo = useMemo(() => {
        const { hours, minutes, weekDay } = getFormatDate();
        const greetWords = getGreeting();
        return {
            time: hours && minutes ? `${hours}:${minutes}` : '',
            weekDay: weekDay || '',
            greetWords
        };
    }, []);
    const Jump = (item, index) => {
    };
    useEffect(() => {
    }, []);
    return (createElement("div", { className: `card-greet ${chatMsgs.showAnimation ? 'card-greet-animation-in' : ''}` },
        chatMsgs.showAnimation ? (createElement("section", { className: "card-greet-intro" },
            createElement("div", { className: "card-greet-intro-avatar" },
                createElement(PagImg, { className: "card-greet-intro-avatar-img", url: constMap.robotImg, defaultImg: constMap.robotImgDefault })),
            createElement("div", { className: "card-greet-intro-content" },
                createElement("p", { className: "card-greet-title", role: "text" },
                    createElement(TypedText, { text: pageData?.title ||
                            `${dateInfo.greetWords}! 我是${constMap.robotName}`, typeSpeed: isHistory ? 0 : 50 })),
                createElement("p", { className: "card-greet-desc", role: "text" },
                    createElement("div", { className: "card-greet-desc-border" }),
                    createElement("div", null, pageData?.content))))) : null,
        createElement("section", { className: "card-greet-content" },
            createElement("div", { className: "card-greet-content-top" },
                createElement("div", { className: "card-greet-content-title" }, "\u5C0F\u667A\u63A8\u8350"),
                createElement("div", { className: "card-greet-content-desc" },
                    createElement("span", null, dateInfo.weekDay),
                    createElement("span", { role: "text", "aria-label": readDateTime(dateInfo.time) }, dateInfo.time))),
            createElement("div", { className: `card-greet-btns ${cardStyle === 'twoButtons' ? 'button-style-two' : ''}` }, pageData?.buttons.map((item, index) => (createElement("div", { key: index, role: "button", tabIndex: 0, "aria-label": item.titleValue, className: "card-greet-bubble", "aria-disabled": isHistory, onClick: () => {
                    Jump(item, index);
                } },
                createElement("span", null,
                    " ",
                    item.titleValue),
                createElement("div", { role: "button", className: "card-greet-arrow" }))))))));
}
export default CardGreet;
